import { TAB_BAR_ENUMS } from "./constants";

const tranformTabList = (tabList) => {
  const filteredTabList = tabList?.filter(
    (item) => item?.enumKey !== "liveClassAttendance"
  );

  return filteredTabList?.map?.((item, i) => ({
    ...item,
    id: TAB_BAR_ENUMS[item?.enumKey],
    label: item?.label?.toLowerCase(),
  }));
};

export default tranformTabList;
